import {
	OrderSummaryCardChip,
	OrderSummaryCardTooltip,
	OrderSummaryCardTooltipText
} from "components/OrderSummaryCard/OrderSummaryCard.styles.ts";
import { getOrderTypeDisplayLabel } from "utils/order.ts";

export interface OrderChip {
	label: string;
	toolTip: string | null | undefined;
}

export const OrderSummaryChip = ({ chip }: { chip: OrderChip }) =>
	chip.toolTip ? (
		<OrderSummaryCardTooltip
			title={<OrderSummaryCardTooltipText>{chip.toolTip}</OrderSummaryCardTooltipText>}
			placement="bottom-start"
			aria-label={chip.toolTip}
		>
			<OrderSummaryCardChip
				label={getOrderTypeDisplayLabel(chip.label)}
				chipTitle={chip.label}
			/>
		</OrderSummaryCardTooltip>
	) : (
		<OrderSummaryCardChip
			label={getOrderTypeDisplayLabel(chip.label)}
			chipTitle={chip.label}
		/>
	);
